import { render, staticRenderFns } from "./AddTransMetaboProjectDialog.vue?vue&type=template&id=f4dcc196&scoped=true"
import script from "./AddTransMetaboProjectDialog.vue?vue&type=script&lang=js"
export * from "./AddTransMetaboProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./AddTransMetaboProjectDialog.vue?vue&type=style&index=0&id=f4dcc196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dcc196",
  null
  
)

export default component.exports